<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section id="page-accordion">
      <form class="row" [formGroup]="formGroup">
        <div class="col-12">
          <!--Detail Section-->
          <div id="detail-section" class="card" [ngClass]="activeTab === 'detail' ? 'active' : ''">
            <div class="card-title px-2 mb-0" (click)="changeTab('detail')">
              <h4>{{ "DETAIL_SINGULAR" | translate }}</h4>
            </div>
            <section [ngClass]="activeTab === 'detail' ? 'card-body' : ''">
              <div class="row">
                <div class="form-group col-12">
                  <label for="title">{{ "TITLE" | translate }}<sup class="text-danger">*</sup></label>
                  <input type="text" class="form-control {{ fieldHasErrors('title') ? 'is-invalid' : '' }}" formControlName="title" id="title">
                  <div class="invalid-feedback" *ngIf="formGroup.controls.title.errors?.required">{{ "ERRORS.FIELD_TITLE" | translate }}</div>
                </div>
                <div class="form-group col-lg-6 col-12">
                  <label for="figure_id">{{ "FIGURE" | translate }}<sup class="text-danger">*</sup></label>
                  <ng-container *ngIf="jobPosition && jobPosition.request_id; else ngSelectFigure">
                    <input type="text" class="form-control" readonly [value]="jobPosition.figure_name">
                  </ng-container>
                  <ng-template #ngSelectFigure>
                    <ng-select [items]="figures" [closeOnSelect]="true" [clearable]="false"
                               class="{{ fieldHasErrors('figure_id') ? 'is-invalid' : '' }}" id="figure_id" formControlName="figure_id"
                               placeholder="{{ 'SELECT_FIGURE' | translate }}" bindLabel="name" bindValue="id"></ng-select>
                    <div class="invalid-feedback" *ngIf="formGroup.controls.figure_id.errors?.required">{{ "ERRORS.FIELD_FIGURE" | translate }}</div>
                  </ng-template>
                </div>
                <div class="form-group col-lg-6 col-12">
                  <label for="category_id">{{ "JOB_CATEGORY" | translate }}<sup class="text-danger">*</sup></label>
                  <ng-select [items]="jobCategories" [multiple]="false" [closeOnSelect]="true" [clearable]="false"
                             class="{{ fieldHasErrors('category_id') ? 'is-invalid' : '' }}" id="category_id" formControlName="category_id"
                             placeholder="{{ 'INSERT.SELECT_JOB_CATEGORY' | translate }}" bindLabel="name" bindValue="id"></ng-select>
                  <div class="invalid-feedback" *ngIf="formGroup.controls.category_id.errors?.required">{{ "INSERT.SELECT_JOB_CATEGORY" | translate }}</div>
                </div>
                <div class="form-group col-lg-6 col-12">
                  <label for="city_id">{{ "CITY" | translate }}<sup class="text-danger">*</sup></label>
                  <ng-container *ngIf="jobPosition && jobPosition.request_id; else ngSelectCity">
                    <input type="text" class="form-control" readonly [value]="jobPosition.city_name">
                  </ng-container>
                  <ng-template #ngSelectCity>
                    <ng-select [items]="_citiesService.list" [multiple]="false" [closeOnSelect]="true" [clearable]="false"
                               class="{{ fieldHasErrors('city_id') ? 'is-invalid' : '' }}" id="city_id" formControlName="city_id"
                               placeholder="{{ 'ERRORS.SELECT_CITY' | translate }}" bindLabel="nice_name" bindValue="id"></ng-select>
                    <div class="invalid-feedback" *ngIf="formGroup.controls.city_id.errors?.required">{{ "ERRORS.SELECT_CITY" | translate }}</div>
                  </ng-template>
                </div>
                <div class="form-group col-lg-6 col-12">
                  <label for="site_id">{{ "MODE" | translate }}<sup class="text-danger">*</sup></label>
                  <ng-container *ngIf="jobPosition && jobPosition.request_id; else ngSelectSite">
                    <input type="text" class="form-control" readonly [value]="jobPosition.site_name">
                  </ng-container>
                  <ng-template #ngSelectSite>
                    <ng-select [items]="locations" [closeOnSelect]="true" [clearable]="false"
                               class="{{ fieldHasErrors('site_id') ? 'is-invalid' : '' }}" id="site_id" formControlName="site_id"
                               placeholder="{{ 'ERRORS.SELECT_MODE' | translate }}" bindLabel="name" bindValue="id"></ng-select>
                    <div class="invalid-feedback" *ngIf="formGroup.controls.site_id.errors?.required">{{ "ERRORS.SELECT_MODE_ERROR" | translate }}</div>
                    <div class="invalid-feedback" *ngIf="formGroup.controls.site_id.errors?.min || formGroup.controls.site_id.errors?.max">{{ "MODE" | translate }} {{ "ERRORS.NOT_VALID" | translate }}</div>
                  </ng-template>
                </div>
                <div class="form-group col-lg-6 col-12">
                  <label for="request_id">{{ "REQUEST" | translate }}</label>
                  <ng-container *ngIf="jobPosition && jobPosition.request_id; else ngSelectRequest">
                    <input type="text" class="form-control" readonly [value]="jobPosition.request_name">
                  </ng-container>
                  <ng-template #ngSelectRequest>
                  <ng-select [items]="requests" [closeOnSelect]="true" [clearable]="true" (change)="manageRequest()" id="request_id" formControlName="request_id"
                             placeholder="{{ 'INSERT.SELECT_REQUEST' | translate }}" bindLabel="request_name" bindValue="id"></ng-select>
                  </ng-template>
                </div>
                <div class="form-group col-lg-6 col-12">
                  <label for="start_date">{{ "VALID_SINCE" | translate }}</label>
                  <input id="start_date" type="date" class="form-control" formControlName="start_date" />
                </div>
              </div>
            </section>
          </div>

          <!--Summary Section-->
          <div id="summary-section" class="card" [ngClass]="activeTab === 'summary' ? 'active' : ''">
            <div class="card-title px-2 mb-0" (click)="changeTab('summary')">
              <h4>{{ "SUMMARY" | translate }}</h4>
            </div>
            <section [ngClass]="activeTab === 'summary' ? 'card-body' : ''">
              <div class="row">
                <div class="form-group col-12">
                  <angular-editor *ngIf="!isSubmittingForm" id="summary" [config]="_utilService.defaultEditorConfig" [formControlName]="'summary'"></angular-editor>
                  <div *ngIf="isSubmittingForm" [innerHTML]="formGroup.value.summary"></div>
                </div>
              </div>
            </section>
          </div>

          <!--Description Section-->
          <div id="description-section" class="card" [ngClass]="activeTab === 'description' ? 'active' : ''">
            <div class="card-title px-2 mb-0" (click)="changeTab('description')">
              <h4>{{ "DESCRIPTION" | translate }}</h4>
            </div>
            <section [ngClass]="activeTab === 'description' ? 'card-body' : ''">
              <div class="row">
                <div class="form-group col-12">
                  <angular-editor *ngIf="!isSubmittingForm" id="description" [config]="_utilService.defaultEditorConfig" [formControlName]="'description'"></angular-editor>
                  <div *ngIf="isSubmittingForm" [innerHTML]="formGroup.value.description"></div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </form>
      <div class="d-flex justify-content-end">
        <button *ngIf="!isSubmittingForm" type="button" class="btn btn-primary" (click)="isEdit ? submitUpdate() : submitCreate()">{{ isEdit ? ("EDIT" | translate) : ("SAVE" | translate) }}</button>
        <div *ngIf="isSubmittingForm">
          <span class="button-penguin">{{ isEdit ? ("EDIT_DOTS" | translate) : ("SAVE_DOTS" | translate) }}</span>
          <img [width]="90" src="../../../../../assets/images/misc/bit-loading-animation.gif" alt="bit" />
        </div>
      </div>
    </section>
  </div>
</div>
